import React from 'react';
import logo from './images/hotel logo.jpeg';
import './App.css';
import BookingFormPage from './pages/BookingFormPage';
import BookingListPage from './pages/BookingListPage';
import SearchPage from './pages/SearchPage';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Hotel Booking App</h1>
        <BookingFormPage />
        <BookingListPage />
        <SearchPage />
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
